import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';

import { style } from '../../../components/pdf/fontstyles';
import { AutoText } from '../../../components/pdf/autoText';



        
const SrVachanPatra = ({ result }) => (
  
              <View size="A4" style={style.page}> 
                 <Text style={[style.title, style.marathi, { fontSize: 18 }]}>वचनपत्र</Text>
                 <View style={[style.solidLine,{marginBottom: 10}]}></View>
            
                <AutoText style={[style.paragraph, { marginTop: 10 }]}>मी {result.employeeName} असे वचन देतो की चुकीच्या वेतन निश्चितीमुळे किंवा पुढे 
                    वेतन निश्चिती विसंगती आढळून आल्यामुळे  
                    मला अतिप्रदान झाल्याचे निदर्शनास आल्यास भविष्यात मला प्रदान करण्यात येणाऱ्या रकमेतून सामायोजित करून किंवा इतर प्रकारे मी शासनास परत करेन 
                </AutoText>


                <View style={[{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 80 },style.marathi]}>

                <Text>दिनांक : </Text>
                <Text style={[style.signature]}>सही</Text>
              </View>

              <View style={[{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 20 },style.marathi]}>
                <Text>ठिकाण : </Text>
                <AutoText style={[style.signature]}>नाव: {result.employeeName}</AutoText>
              </View>

           </View>

);

export default SrVachanPatra;